import { render, staticRenderFns } from "./MessageTemplateEditor.vue?vue&type=template&id=61e3e868&"
import script from "./MessageTemplateEditor.vue?vue&type=script&lang=js&"
export * from "./MessageTemplateEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports